import { render, staticRenderFns } from "./cusplierBank.vue?vue&type=template&id=46c75853&scoped=true"
import script from "./cusplierBank.vue?vue&type=script&lang=js"
export * from "./cusplierBank.vue?vue&type=script&lang=js"
import style0 from "./cusplierBank.vue?vue&type=style&index=0&id=46c75853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c75853",
  null
  
)

export default component.exports